import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";
import "./App.css";
import { getAccount, connect, signMessage } from "@wagmi/core";
import { injected } from "@wagmi/connectors";
import { config } from "./config";
import { useParams } from "react-router-dom";
import { useAccount } from "wagmi";
import MuteComponent from "./components/mute";

// };

function ShooterGame() {
  const { address } = useAccount();

  useEffect(() => {
    console.log("id, window", window);

    if (!window) return;
    // (window as any).initializeExampleFn();
    (window as any).initializeSpaceRock(window);
    (window as any).initializeShipFn(window);
    (window as any).init();
  }, [address]);

  return (
    <div
      id=""
      className=""
      style={
        {
          position: "relative",
          display: "flex"
          // height: "1000px",
          // marginTop: "50px",
        }
      }
    >
    
      <div id="content">
        <canvas
          id="gameCanvas"
          width="960"
          height="400"
          style={{ background: '/assets/space-rock/art/space.jpg' }}
        ></canvas>
      </div>

      <div id="error">
        <h1>Sorry!</h1>

        <p>SoundJS is not currently supported in your browser.</p>

        <p>
          Please{" "}
          <a href="http://github.com/CreateJS/SoundJS/issues" target="_blank">
            log a bug
          </a>
          with the device and browser you are using. Thank you.
        </p>
      </div>

      <div id="mobile">
        <h1>Sorry!</h1>

        <p>
          Mobile devices require sound to be played inside of user events, which
          this demo does not do.
        </p>

        <p>
          Please{" "}
          <a href="http://github.com/CreateJS/SoundJS/issues" target="_blank">
            log a bug
          </a>
          with the OS and browser if you see this on a device that is not
          mobile. Thank you.
        </p>
      </div>
      <MuteComponent/>
    </div>
  );
}

export default ShooterGame;
